<template>
  <div>

<el-row>
  <el-col :span="12"><div class="grid-content bg-purple">
    <el-button :loading="loading" type="primary" slot="append" icon="el-icon-circle-plus" @click="onAdd">我要竞价</el-button>
    </div></el-col>
  <el-col :span="12">
		<div class="grid-content bg-purple-light">
		<el-dropdown split-button type="primary" @command="handleCommand" @click="replaces"
		style="margin-left:6px;">
		  {{ switchs }}
		  <el-dropdown-menu slot="dropdown">
		    <el-dropdown-item command="竞价中">竞价中</el-dropdown-item>
		    <el-dropdown-item command="竞价成功">竞价成功</el-dropdown-item>
				<el-dropdown-item command="竞价失败">竞价失败</el-dropdown-item>
		  </el-dropdown-menu>
		</el-dropdown>
    </div>
		</el-col>
</el-row>
  <el-table :data="list" v-loading="loading" style="width: 100%">
    <el-table-column fixed prop="id" label="ID" width="50"></el-table-column>
    <el-table-column fixed prop="ad_date" label="竞价日期" width="100"></el-table-column>
		<el-table-column prop="point" label="竞价积分"></el-table-column>
    <el-table-column prop="position_id" label="竞价广告位">
			<template slot-scope="scope">
			  {{scope.row.position?scope.row.position.desc:''}}
			</template>
    </el-table-column>
		<el-table-column prop="ad_id" label="广告信息">
			<template slot-scope="scope">
			  {{scope.row.message?scope.row.message.title:''}}
			</template>
		</el-table-column>
    <el-table-column v-if="isadmin==1" label="竞价用户" width="200">
      <template slot-scope="scope">
        {{scope.row.user?scope.row.user.name:''}}
      </template>
    </el-table-column>
    <el-table-column label="状态" width="120">
      <template slot-scope="scope">
       <p v-if="scope.row.status==-1"><span style="color: green">竞价中</span></p>
       <p v-else-if="scope.row.status==1"><span style="color: red">竞价成功</span></p>
			 <p v-else><span style="color: red">竞价失败</span></p>
      </template>
    </el-table-column>
    <el-table-column fixed="right" v-if="page.type==2" label="操作" width="100">
      <template slot-scope="scope">
				<el-button v-if="scope.row.recovery_status==-1" type="primary" @click='recover_point(scope.row.id)'>回收积分</el-button>
				<p v-else-if="scope.row.recovery_status==1"><span style="color: red">积分已回收</span></p>
      </template>
    </el-table-column>
  </el-table>


<MyPagination :loading="loading" :page="page" @current-change="currentChange"></MyPagination>

  </div>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import {MyStorage,MyMessage } from '@/common.js';
export default {
  components: {
    MyPagination
  },
    data() {
        return {
					switchs: "竞价中",
          isadmin:MyStorage.getItem('isadmin'),
          loading:false,
          page:{
            key:'',
            page:1,
            total:0,
            last_page:1,
            per_page:10,
						type:-1
          },
          list:null,
        }
    },
    mounted(){
        console.log('广告');
        this.loadData();
    },
    methods : {
			recover_point(id){
				this.loading = true;
				this.api.doRecovery(
				  {id:id},
				  res => {
				  //console.log(res);return false;
						if(res.data.code!=1){
							MyMessage.error(res.data.msg);
							this.loading = false;
						}else{
						MyMessage.success(res.data.msg);
						this.loadData();
							this.loading = false;
							//this.page.type = 2;
							
							
						}
				  },
				  err => {
				    this.loading = false;
				  }
				);
				console.log(id);
			},
			replaces(){
			  if(this.switchs=="竞价中"){
			    this.switchs="竞价中";
			    this.page.type = -1;
			    this.loadData();
			  }else if(this.switchs=="竞价成功"){
			    this.switchs="竞价成功";
			    this.page.type = 1;
			    this.loadData();
			  }else if(this.switchs=="竞价失败"){
			    this.switchs="竞价失败";
			    this.page.type = 2;
			    this.loadData();
			  }
			},
			// 打开店铺和关闭店铺页面切换
			handleCommand(e) {
			  if (e == '竞价中') {
			    this.page.type = -1;
			    this.loadData();
			  } else if (e == '竞价成功') {
			    this.page.type = 1;
			    this.loadData();
			  }else if (e == '竞价失败') {
			    this.page.type = 2;
			    this.loadData();
			  }
			  this.switchs = e;
			},
      loadData(){
        this.loading=true;
        this.api.bidding_list(this.page,res=>{
          console.log(res.data);
          this.list=res.data.data;
          this.page.total=res.data.total;
          this.loading=false;
        });
      },
      currentChange(currentPage) {
        this.page.page=currentPage
        this.loadData();
        console.log(currentPage);
      },
      onSearch() {
        this.currentChange(1);
      },
      onAdd(){
        this.$router.push("/ad_bidding");
      }
    }
}
</script>
